import { render, staticRenderFns } from "./cgl-study-detail-info.vue?vue&type=template&id=551cf2b5&"
import script from "./cgl-study-detail-info.vue?vue&type=script&lang=js&"
export * from "./cgl-study-detail-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports